export const VALIDATE_IP_FAILED = 'VALIDATE_IP_FAILED';

export function validateIpFailedAction() {
	return {
		type: VALIDATE_IP_FAILED,
	};
}
